import useSWR from 'hooks/useSWR';

export default ({ company_id }) =>
  useSWR({
    url: `/v1/e_cards/presets?company_id=${company_id}`,
    swrOptions: {
      if: Boolean(company_id)
    }
  });
